import React from "react";
import i18n from "@microdoing/shared/i18n";
import { Box, MainText } from "app/components/common";
import theme from "app/Theme/Theme";
import LinearGradient from "react-native-linear-gradient";
import CarotIcon from "app/components/Icons/CarotIcon";
import normalize from "app/utils/normalize";
import { isWeb, isWebDesktop } from "@microdoing/shared/utils/deviceDetectors";
import { Platform } from "react-native";

const LABEL_HEIGHT = normalize(24);

interface Props {
  label?: string;
}

const CardLabel = ({ label = i18n.t("pending-action") }: Props) => {
  return (
    <Box
      position="absolute"
      top={isWebDesktop ? -15 : 0}
      zIndex={9999}
      right={isWebDesktop ? -10 : -5}
      elevation={1}
      backgroundColor="transparent"
      borderRadius={6}
      borderBottomRightRadius={0}
      minHeight={LABEL_HEIGHT}
    >
      <LinearGradient
        style={{
          minWidth: isWeb ? normalize(120) : normalize(20),
          minHeight: LABEL_HEIGHT,
          shadowColor: "rgba(0, 0, 0, 0.11)",
          shadowOpacity: 1,
          shadowOffset: {
            height: 4,
            width: 0,
          },
          shadowRadius: 4,
          paddingHorizontal: theme.spacing.s,
          paddingVertical: theme.spacing.xxs,
          borderRadius: 6,
          borderBottomRightRadius: 0,
          alignContent: "center",
          justifyContent: "center",
        }}
        start={{ x: 0, y: 0 }}
        end={{ x: 1, y: 0 }}
        colors={[
          theme.colors["gradient.ribon.start"],
          theme.colors["gradient.ribon.end"],
        ]}
      >
        <MainText
          textAlign="center"
          variant="l2-bold"
          color="neutral.white"
          style={{
            paddingTop: Platform.OS === "android" ? 0 : theme.spacing.xxs,
          }}
        >
          {label}
        </MainText>
      </LinearGradient>
      <Box position="absolute" bottom={-15} right={0} zIndex={1}>
        <CarotIcon color={theme.colors["brand.500"]} />
      </Box>
    </Box>
  );
};

export default CardLabel;
